// extracted by mini-css-extract-plugin
export default {"pastAlertHeader":"_17FP68kd62SzCD90SwI5Ju","pastAlertBody":"_3HKqEdleNCEnHr6-jlfqyU","trueAlert":"_2sjsJDsaiv_-troV87Ob7z","actionBtn":"_1oLDUd7WWC0uLYxzc0zJAE"};